export const EMAIL_REGEX = /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_REGEX =
  /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export interface MaskOptions {
  mask: string;
  patternsMap?: { [key: string]: RegExp };
}

export function applyMask(input: string, options: MaskOptions) {
  const { mask = "", patternsMap = {} } = options;
  let output = "";
  let index = 0;
  for (let i = 0; i < mask.length; i++) {
    const ch = mask[i];
    const pattern = patternsMap[ch];
    if (pattern) {
      const regex = new RegExp(pattern);
      const match = regex.exec(input.slice(index));
      if (match) {
        output += match[0];
        index += match[0].length;
      } else {
        break;
      }
    } else {
      output += ch;
      index++;
    }
  }
  return output;
}

export function parseInlineStyle(str: string): string {
  try {
    return atob(str);
  } catch (e) {
    return "";
  }
}

export function elementToString(currentElement: any) {
  let string = "";

  let element = "";
  if (currentElement.tagName !== undefined) {
    element = currentElement.tagName.toLowerCase();
  }

  let id = "";
  if (currentElement.id !== undefined) {
    id = currentElement.id;
  }

  let classes: any[] = [];
  if (currentElement.classList !== undefined) {
    classes = Array.from(currentElement.classList);
  }

  string += element;

  if (id !== "") {
    string += "#" + id;
  }

  if (classes.length > 0) {
    string += "." + classes.join(".");
  }

  return string;
}

export function pathToString(path: any) {
  return path.reduce(function (previousValue: any, currentElement: any) {
    let string = "";

    let currentElementString = elementToString(currentElement);

    if (currentElementString !== "") {
      string = currentElementString;
    }

    if (currentElementString === "") {
      string = previousValue;
    }

    if (currentElementString !== "" && previousValue !== "") {
      string = currentElementString + " > " + previousValue;
    }

    return string;
  }, "");
}

export function closestInPath(tagName: string, path: any) {
  let tagNameUppercase = tagName.toUpperCase();

  // Spacing here seems to matter.
  return path.reduce(function (previous: any, current: any) {
    return previous !== null && previous.tagName === tagNameUppercase
      ? previous
      : current.tagName === tagNameUppercase
        ? current
        : null;
  }, null);
}
